export default __webpack_public_path__ + "a35fce6ccac37b635e1ad99a85371421.svg";